"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M17.643 9.998a7.645 7.645 0 1 1-15.29 0 7.645 7.645 0 0 1 15.29 0Zm-1.434 7.835a9.955 9.955 0 0 1-6.211 2.163C4.476 19.996 0 15.519 0 9.998 0 4.476 4.476 0 9.998 0c5.521 0 9.998 4.476 9.998 9.998A9.954 9.954 0 0 1 17.994 16l5.118 5.3a1.279 1.279 0 1 1-1.839 1.775l-5.064-5.244v.002Z",
    clipRule: "evenodd"
  })]
});